import(/* webpackMode: "eager", webpackExports: ["ClaimableFeesTab"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/claim/(fees)/_ui/claimable-fees-tab.tsx");
